// extracted by mini-css-extract-plugin
module.exports = {"container":"foods_container__3KXuO","right-side":"foods_right-side__xZOQJ","right-side-ltr":"foods_right-side-ltr__1-6yX"};